exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".my-app__game{margin:5rem auto;padding:0 3rem}.my-app__g__wrapper{padding:2rem}.my-app__gw__equation{width:100%;height:3rem;display:inline-block;text-align:center;margin:1rem 0}.my-app__gwe__number,.my-app__gwe__operator{display:inline-block;width:3rem;line-height:3rem;font-size:2.5rem;margin:0 .5rem}.my-app__g__stats{text-align:center;font-size:1.8rem}.my-app__gs__score{margin:2rem 0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/components/Game/game.scss
// module id = 223
// module chunks = 0